module.exports = __webpack_public_path__ + "static/media/logo_texto_preto.ea9ac7a3.png";